import React, { useEffect } from "react";
import { useRef, useState, useContext } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Spinner,
  Table,
  ListGroup,
  InputGroup,
} from "react-bootstrap";
import API_BASE_URL from "../../config";
import { AuthContext } from "../../utility/AuthContext";
import { authFetch } from "../../utility/authFetch";

function WaitingPatientTest({ setLoader, setSearch, search, id, name }) {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tests, setTests] = useState([]);
  const [filteredTests, setFilteredTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [query, setQuery] = useState("");

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/doctor-wise-tests?doctor=${user.name}`
        );
        const result = await response.json();
        setTests(result.tests || []);
      } catch (error) {
        console.error("Error fetching tests:", error);
      }
    };

    fetchTests();
  }, [search, id, user.name]);

  useEffect(() => {
    const filtered = tests.filter((t) =>
      t.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredTests(filtered);
  }, [query, tests]);

  const handleSelectTest = (test) => {
    setSelectedTests((prev) => {
      const isSelected = prev.find((t) => t.name === test.name);
      if (isSelected) {
        // Remove if already selected
        return prev.filter((t) => t.name !== test.name);
      } else {
        // Add if not selected
        return [...prev, test];
      }
    });
  };

  const handleRemove = (name) => {
    setSelectedTests((prev) => prev.filter((t) => t.name !== name));
  };

  const totalAmount = selectedTests.reduce(
    (sum, test) => sum + Number(test.rate || 0),
    0
  );

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    const url = `${API_BASE_URL}/api/waiting-patient-tests`;

    formData.append("name", name);
    formData.append("id", id);
    formData.append("tests", JSON.stringify(selectedTests));

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Tests assigned successfully");
        setIsSubmitting(false);
        setTests([]);
        setFilteredTests([]);
        setSelectedTests([]);
        setQuery("");
        setLoader(false);
        setSearch(true);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <div className="d-flex flex-row justify-content-between">
          <h5 className="mb-3">Tests for Patients</h5>
          <Button onClick={() => setSearch(true)} variant="warning">
            Go Back
          </Button>
        </div>
        <Form onSubmit={handleSubmit}>
          <Row className="align-items-end g-3">
            <Col md={4}>
              <Form.Group className="mb-3" controlId="formPatientName">
                <Form.Label>
                  Patient Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  required
                  value={name}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group controlId="formTests" className="mb-3">
                <Form.Label>Select Tests</Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control
                    type="text"
                    placeholder="Search tests..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    autoComplete="off"
                  />
                </InputGroup>

                {/* Clickable filtered results */}
                {query && filteredTests.length > 0 && (
                  <ListGroup
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      cursor: "pointer",
                    }}
                  >
                    {filteredTests.map((test, index) => (
                      <ListGroup.Item
                        key={index}
                        onClick={() => handleSelectTest(test)}
                        active={selectedTests.some((t) => t.name === test.name)}
                        className="d-flex justify-content-between align-items-center"
                      >
                        {test.name}
                        {selectedTests.some((t) => t.name === test.name) && (
                          <span className="text-success fw-bold">✔</span>
                        )}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                )}

                {query && filteredTests.length === 0 && (
                  <p className="text-muted mt-2">No tests found.</p>
                )}
              </Form.Group>
            </Col>
          </Row>
          {selectedTests.length > 0 && (
            <Table bordered hover responsive className="mt-3">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Test Name</th>
                  <th>Location</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {selectedTests.map((test, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemove(test.name)}
                      >
                        Remove
                      </Button>
                    </td>
                    <td>{test.name}</td>
                    <td>{test.location}</td>
                    <td>{test.rate}</td>
                  </tr>
                ))}
                <tr className="fw-bold table-secondary">
                  <td colSpan={3} className="text-end">
                    Total
                  </td>
                  <td>{totalAmount.toFixed(2)}</td>
                </tr>
              </tbody>
            </Table>
          )}

          <Button variant="primary" type="submit" disabled={isSubmitting}>
            SUBMIT
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default WaitingPatientTest;
